import { useQuery } from '@tanstack/react-query';
import { fetchStandardGenres } from './fetchStandardGenres';
import { GlobalReactQueryOptions } from '../../../../config';

export const useStandardGenres = (fiction: boolean | undefined, category: string | undefined, searchQuery = '') => {
    return useQuery(
        ['standardGenres', { fiction, category, searchQuery }],
        () => fetchStandardGenres(fiction ?? false, category ?? '', searchQuery),
        {
            ...GlobalReactQueryOptions,
            enabled: typeof fiction === 'boolean' && !!category
        }
    );
};
